(function () {
    if (window.agtCleanVariantPickerLoaded) return;
    window.agtCleanVariantPickerLoaded = true;

    var SOURCE_SELECTOR = '.agt-clean-vp__source variant-picker';

    /* ---------- Daten ---------- */

    function getVariants(root) {
      if (root.__agtVariants) return root.__agtVariants;

      var node = root.querySelector('[data-agt-vp-variants]');

      try {
        root.__agtVariants = JSON.parse(node ? node.textContent : '[]');
      } catch (error) {
        root.__agtVariants = [];
      }

      return root.__agtVariants;
    }

    function findVariant(variants, options) {
      if (!Array.isArray(variants) || !Array.isArray(options) || !options.length) return null;

      return variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== options.length) return false;

        return variant.options.every(function (value, index) {
          return String(value).trim() === String(options[index]).trim();
        });
      }) || null;
    }

    function formatMoneyDiff(diff) {
      if (!diff) return '';

      var sign = diff > 0 ? '+' : '-';
      var amount = Math.abs(diff) / 100;

      return ' (' + sign + amount.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' \u20AC)';
    }

    /* ---------- Selects ---------- */

    function getMobileSelects(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-agt-mobile-select]'));
    }

    function getSelectedOptions(root) {
      return getMobileSelects(root).map(function (select) {
        return select.value;
      });
    }

    function readSourceOptions(root) {
      var source = root.querySelector(SOURCE_SELECTOR);
      var options = [];

      if (!source) return options;

      source.querySelectorAll('.option-selector[data-index]').forEach(function (group) {
        var index = Number(group.dataset.index || 1) - 1;
        var active = group.querySelector('.custom-select__option[aria-selected="true"], [role="option"][aria-selected="true"]');
        var checked = group.querySelector('input[type="radio"]:checked');

        options[index] = active
          ? (active.dataset.value || '')
          : (checked ? checked.value : '');
      });

      return options;
    }

    /* ---------- Formular ---------- */

    function updateFormVariantId(root, variant) {
      if (!variant) return;

      root.dataset.currentVariantId = String(variant.id);
      root.dataset.currentPrice = String(variant.price || 0);

      var scope = root.closest('.js-product') || document;

      scope
        .querySelectorAll('form[action*="/cart/add"] input[name="id"], form.js-product-form input[name="id"]')
        .forEach(function (input) {
          /* Nur feuern, wenn sich der Wert wirklich aendert.
             Verhindert eine Endlosschleife change -> on:variant:change -> change. */
          if (String(input.value) === String(variant.id)) return;

          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    /* ---------- Anzeige ---------- */

    function updateVisibleValues(root) {
      getMobileSelects(root).forEach(function (select) {
        var field = select.closest('.agt-clean-vp__field');
        var label = field && field.querySelector('[data-agt-selected-value]');

        if (label && select.value) {
          label.textContent = select.value;
        }
      });
    }

    function updateMobilePriceDiffs(root) {
      var variants = getVariants(root);
      var selected = getSelectedOptions(root);
      var current = findVariant(variants, selected);
      var basePrice = current ? current.price : Number(root.dataset.currentPrice || 0);

      getMobileSelects(root).forEach(function (select) {
        var optionIndex = Number(select.dataset.optionPosition || 1) - 1;

        Array.prototype.slice.call(select.options).forEach(function (option) {
          var candidate = selected.slice();
          candidate[optionIndex] = option.value;

          var match = findVariant(variants, candidate);
          var diff = match ? match.price - basePrice : 0;

          option.textContent = option.value + formatMoneyDiff(diff);
          option.disabled = match ? match.available === false : false;
        });
      });
    }

    function updateDesktopPriceDiffs(root) {
      var source = root.querySelector(SOURCE_SELECTOR);
      var variants = getVariants(root);

      if (!source || !variants.length) return;

      var selected = readSourceOptions(root);
      var current = findVariant(variants, selected);
      var basePrice = current ? current.price : Number(root.dataset.currentPrice || 0);

      source.querySelectorAll('.option-selector[data-index]').forEach(function (group) {
        var optionIndex = Number(group.dataset.index || 1) - 1;

        group.querySelectorAll('.custom-select__option, [role="option"]').forEach(function (item) {
          var itemValue = (item.dataset.value || '').trim();

          /* Ohne data-value wuerde der Label-Text sonst geleert werden. */
          if (!itemValue) return;

          var candidate = selected.slice();
          candidate[optionIndex] = itemValue;

          var match = findVariant(variants, candidate);
          var diff = match ? match.price - basePrice : 0;

          var labelSpan = item.querySelector('span:not(.variant-price-diff)');
          var priceEm = item.querySelector('.variant-price-diff');

          if (!labelSpan) {
            labelSpan = document.createElement('span');
            labelSpan.className = 'pointer-events-none';
            item.prepend(labelSpan);
          }

          if (!priceEm) {
            priceEm = document.createElement('em');
            priceEm.className = 'pointer-events-none variant-price-diff';
            item.appendChild(priceEm);
          }

          labelSpan.textContent = itemValue;
          priceEm.textContent = formatMoneyDiff(diff);
        });
      });
    }

    /* ---------- Synchronisierung ---------- */

    function syncSourceFromMobile(select) {
      var root = select.closest('[data-agt-clean-vp]');
      if (!root || root.__agtSyncing) return;

      root.__agtSyncing = true;

      try {
        var source = root.querySelector(SOURCE_SELECTOR);
        var position = select.dataset.optionPosition;
        var group = source && source.querySelector('.option-selector[data-index="' + position + '"]');

        if (group) {
          var customSelect = group.querySelector('custom-select');

          if (customSelect) {
            var target = Array.prototype.slice
              .call(customSelect.querySelectorAll('.custom-select__option, [role="option"]'))
              .find(function (option) {
                return String(option.dataset.value || '').trim() === String(select.value).trim();
              });

            if (target) {
              if (typeof customSelect.selectOption === 'function') {
                customSelect.selectOption(target);
              } else {
                target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
              }
            }
          } else {
            var radio = Array.prototype.slice
              .call(group.querySelectorAll('input[type="radio"]'))
              .find(function (input) {
                return String(input.value).trim() === String(select.value).trim();
              });

            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        var variant = findVariant(getVariants(root), getSelectedOptions(root));

        updateFormVariantId(root, variant);
        updateVisibleValues(root);
        updateMobilePriceDiffs(root);
        updateDesktopPriceDiffs(root);
      } finally {
        /* Flag erst nach dem Event-Durchlauf loesen, damit die vom Theme
           ausgeloesten Folge-Events nicht zurueckschreiben. */
        setTimeout(function () {
          root.__agtSyncing = false;
        }, 300);
      }
    }

    function syncMobileFromSource(root) {
      if (root.__agtSyncing) return;

      var source = root.querySelector(SOURCE_SELECTOR);

      if (source) {
        readSourceOptions(root).forEach(function (value, index) {
          if (!value) return;

          var select = root.querySelector('[data-agt-mobile-select][data-option-position="' + (index + 1) + '"]');

          if (select && select.value !== value) {
            select.value = value;
          }
        });
      }

      var variant = findVariant(getVariants(root), getSelectedOptions(root));

      updateFormVariantId(root, variant);
      updateVisibleValues(root);
      updateMobilePriceDiffs(root);
      updateDesktopPriceDiffs(root);
    }

    /* ---------- Init ---------- */

    function initRoot(root) {
      syncMobileFromSource(root);
    }

    function initAll() {
      document.querySelectorAll('[data-agt-clean-vp]').forEach(initRoot);
    }

    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-agt-mobile-select]');
      if (!select) return;

      syncSourceFromMobile(select);
    });

    document.addEventListener('focusin', function (event) {
      var select = event.target.closest && event.target.closest('[data-agt-mobile-select]');
      if (!select) return;

      var root = select.closest('[data-agt-clean-vp]');
      if (root) updateMobilePriceDiffs(root);
    });

    document.addEventListener('on:variant:change', function () {
      setTimeout(initAll, 80);
    });

    document.addEventListener('shopify:section:load', initAll);

    /* Quick Add fuegt seinen Inhalt per innerHTML ein. Dabei laufen keine
       Scripts, und es feuert kein Shopify-Event. Deshalb beobachten wir das
       DOM und initialisieren neu eingefuegte Picker selbst. */
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        var needsInit = false;

        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) return;

            if (node.matches('[data-agt-clean-vp]') || node.querySelector('[data-agt-clean-vp]')) {
              needsInit = true;
            }
          });
        });

        if (needsInit) setTimeout(initAll, 30);
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();